import { render, staticRenderFns } from "./ViewAssignments.vue?vue&type=template&id=16415bee&scoped=true"
import script from "./ViewAssignments.vue?vue&type=script&lang=js"
export * from "./ViewAssignments.vue?vue&type=script&lang=js"
import style0 from "./ViewAssignments.vue?vue&type=style&index=0&id=16415bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16415bee",
  null
  
)

export default component.exports